export const BUDGET_TYPES = {
    DAILY: 'DAILY',
    MONTHLY: 'MONTHLY',
    LIFETIME: 'LIFETIME',
    UNLIMITED: 'UNLIMITED',
};
